document.addEventListener('DOMContentLoaded', function() {
  // Check if the wrapper already exists
  if (!document.querySelector('.science-and-press-wraper')) {
    // Create the wrapper div and its children
    var wrapper = document.createElement('div');
    wrapper.classList.add('science-and-press-wraper', 'container');  // Added the extra class here

    var leftDiv = document.createElement('div');
    leftDiv.classList.add('science-and-press-left');

    var rightDiv = document.createElement('div');
    rightDiv.classList.add('science-and-press-right');

    // Append the left and right divs to the wrapper
    wrapper.appendChild(leftDiv);
    wrapper.appendChild(rightDiv);

    // Select the sections by their IDs
    var scienceAndPressIndex = document.getElementById('shopify-section-template--16590051442769__science_and_press_index_UDAyCx');
    var featuredPress = document.getElementById('shopify-section-template--16590051442769__featured_press_ViXRmh');
    var ourScienceTeam = document.getElementById('shopify-section-template--16874510844096__our_science_team_kwzCqz');
    var podcasts = document.getElementById('shopify-section-template--16590051442769__podcasts_xFJnWc');
    var featuredBlog = document.getElementById('shopify-section-template--16590051442769__featured_blog_custom_CmJbHp');
    var moreScience = document.getElementById('shopify-section-template--16590051442769__more_science_aUFEwm');

    // Insert the wrapper before the first section
    if (scienceAndPressIndex) {
      scienceAndPressIndex.parentNode.insertBefore(wrapper, scienceAndPressIndex);

      // Use requestAnimationFrame to ensure the DOM is ready for manipulations
      requestAnimationFrame(function() {
        // Append the sections to the respective divs and make them visible
        leftDiv.appendChild(scienceAndPressIndex);
        scienceAndPressIndex.style.display = '';

        if (featuredPress) {
          rightDiv.appendChild(featuredPress);
          featuredPress.style.display = '';
        }
        if (ourScienceTeam) {
          rightDiv.appendChild(ourScienceTeam);
          ourScienceTeam.style.display = '';
        }
        if (podcasts) {
          rightDiv.appendChild(podcasts);
          podcasts.style.display = '';
        }
        if (featuredBlog) {
          rightDiv.appendChild(featuredBlog);
          featuredBlog.style.display = '';
        }
        if (moreScience) {
          rightDiv.appendChild(moreScience);
          moreScience.style.display = '';
        }
      });
    }
  }
});
